import React, { Component } from 'react'

import axios from 'axios'

import Alert from 'react-bootstrap/Alert'
import Button from 'react-bootstrap/Button'
import Col from 'react-bootstrap/Col'
import Container from 'react-bootstrap/Container'
import Form from 'react-bootstrap/Form'
import Row from 'react-bootstrap/Row'

import EmailField from '../fields/email-field'
import NonEmptyTextField from '../fields/non-empty-text-field'
import PasswordField from '../fields/password-field'

import register from '../../../queries/3dmssapi/register'

const RegistrationForm = class extends Component {
  constructor(props) {
    super(props)
    this.state = {
      email: undefined,
      password: undefined,
      registration_code: undefined,

      allow_resubmit: false,
      error_message: 'Error during registration.',
      loading: false,
      notificationShow: false,
      sent: false,
      showErrorNotification: false,
      errors: false
    }

    this.cancelToken = axios.CancelToken.source()
  }

//Lifecycle hooks
  componentWillUnmount() {
    try {
      this.cancelToken.cancel()
    } catch(error) {
      console.log(error)
    }
  }
//End lifecycle hooks

//Custom functions
  handleRegister = (e) => {
    e.preventDefault()
    this.setState({loading: true})

    register(
      this.cancelToken,
      this.state.email,
      this.state.password,
      this.state.registration_code
    )
      .then(response => {
        console.log(response);
        if(response.status === 200 && !response.data.errors) {
          this.setState({
            allow_resubmit: false,
            invalidRegistrationCodeNotificationShow: false,
            showErrorNotification: false,
            notificationShow: true,
            loading: false,
            sent: true
          });
          this.props.setSignedIn()
      } else {
          if (
            response.data.errors &&
            Array.isArray(response.data.errors) &&
            response.data.errors[0].message === 'A unique constraint would be violated on User. Details: Field name = email'
          ) {
            this.setState({
              error_message: 'A user is already registered with that e-mail address.',
              showErrorNotification: true,
              loading: false,
              sent: false,
              allow_resubmit: true
            })
          } else if (
            response.data.errors &&
            Array.isArray(response.data.errors) &&
            response.data.errors[0].message === 'Not a valid registration code'
          ) {
            this.setState({
              error_message: 'Invalid registration code.',
              showErrorNotification: true,
              loading: false,
              sent: false,
              allow_resubmit: true
            })
          } else {
            this.setState({showErrorNotification: true, loading: false, sent: false})
          }
        }
      })
      .catch(error => {
        if(axios.isCancel(error)) {
          console.log(`Request canceled: ${error}`);
          this.setState({errors: true, showErrorNotification: true, loading: false})
        } else {
          console.log(error);
          this.setState({errors: true, showErrorNotification: true, loading: false})
        }
      })
  }

  hideErrorNotification = () => {
    this.setState({showErrorNotification: false})
  }

  hideInvalidRegistrationCodeErrorNotification = () => {
    this.setState({showInvalidRegistrationCodeError: false})
  }

  hideNotification = () => {
    this.setState({notificationShow: false})
  }

  showErrorNotification = () => {
    this.setState({showErrorNotification: true})
  }

  showInvalidRegistrationCodeError = () => {
    this.setState({showInvalidRegistrationCodeError: true})
  }

  showNotification = () => {
    this.setState({notificationShow: true})
  }
//End custom functions

  render() {
    return (
      <React.Fragment>
        <Form>
          <Row>
            <EmailField
              id="rf-email-input"
              invalid_message="Please provide a valid email address."
              label="Email"
              setField={(value) => this.setState({email: value})}
              xs={12}
            />
            <PasswordField
              id="rf-password-input"
              invalid_message="Password must be at least 8 characters long."
              label="Password"
              setField={(value) => this.setState({password: value})}
              xs={12}
            />
            <NonEmptyTextField
              id="rf-registration-code-input"
              invalid_message="Please provide a registration code."
              label="Registration Code"
              setField={(value) => this.setState({registration_code: value})}
              xs={12}
            />
          </Row>
        </Form>
        <Container>
          <Row>
            <Col xs={12}>
              <React.Fragment>
                <Alert show={this.state.notificationShow} onClose={this.hideNotification} dismissible variant="success">
                  Registered!
                </Alert>
                <Alert show={this.state.showErrorNotification} onClose={this.hideErrorNotification} dismissible variant="danger">
                  {this.state.error_message}
                </Alert>
              </React.Fragment>
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <div className="d-flex justify-content-end">
                { !this.state.errors && !this.state.loading && !this.state.sent
                  &&
                  (!this.state.email
                  || !this.state.password
                  || this.state.password.length < 8
                  || !this.state.registration_code)
                  &&
                  <div className="d-flex p-2">
                    {/* For non-modal signin or register */}
                    {this.props.register && !this.props.update &&
                      <Button className="m-2" variant="outline-primary" onClick={() => this.props.register(false)}>Sign In</Button>
                    }
                    {!this.props.update &&
                      <Button className="m-2" variant="outline-primary" disabled>Register</Button>
                    }
                    {this.props.update &&
                      <Button className="m-2" variant="outline-primary" disabled>Save</Button>
                    }
                  </div>
                }
                { !this.state.errors && !this.state.loading && !this.state.sent
                  && this.state.email
                  && this.state.password
                  && this.state.password.length >= 8
                  && this.state.registration_code
                  &&
                  <div className="d-flex p-2">
                    {/* For non-modal signin or register */}
                    {this.props.register && !this.props.update &&
                      <Button className="m-2" variant="outline-primary" onClick={() => this.props.register(false)}>Sign In</Button>
                    }
                    {!this.props.update &&
                      <Button className="m-2" variant="outline-primary" onClick={(e) => this.handleRegister(e)}>Register</Button>
                    }
                    {this.props.update &&
                      <Button className="m-2" variant="outline-primary" onClick={(e) => this.handleUpdate(e)}>Save</Button>
                    }
                  </div>
                }
                { !this.state.errors && this.state.loading &&
                  <Button variant="outline-success" disabled>
                    <span className="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                    {!this.props.update &&
                      <React.Fragment>Registering...</React.Fragment>
                    }
                    {this.props.update &&
                      <React.Fragment>Saving...</React.Fragment>
                    }
                  </Button>
                }
                { !this.state.errors && !this.state.loading && this.state.sent && !this.props.update &&
                  <Button variant="outline-success" disabled>Registered</Button>
                }
                { !this.state.errors && !this.state.loading && this.state.sent && this.props.update &&
                  <Button variant="outline-success" disabled>Saved</Button>
                }
                { this.state.errors &&
                  <Button variant="outline-danger" disabled>Error</Button>
                }
              </div>
            </Col>
          </Row>
        </Container>
      </React.Fragment>
    )
  }
}

export default RegistrationForm
